__turbopack_context__.v({
  "custom-modal": "BurgerMenu-module-scss-module__KJZR5a__custom-modal",
  "custom-popover-trigger": "BurgerMenu-module-scss-module__KJZR5a__custom-popover-trigger",
  "dropdown-list": "BurgerMenu-module-scss-module__KJZR5a__dropdown-list",
  "dropdown-list-item": "BurgerMenu-module-scss-module__KJZR5a__dropdown-list-item",
});
